import React, { useState, useEffect, useCallback, useContext } from "react";
import Btc from "../../images/Home/btc.png";
import { BsFillSendFill, BsThreeDots } from "react-icons/bs";
import { BiCopy } from "react-icons/bi";
import { MdCallReceived } from "react-icons/md";
import { MdCallMade } from "react-icons/md";
import { useFormik } from "formik";
import { GiRecycle } from "react-icons/gi";
import * as Yup from "yup";
import OTPInput from "otp-input-react";
import {
  Label,
  Input,
  ImgDiv,
  QRdiv,
  TabNavigationButton,
  Button,
  ReqButton,
  P,
} from "./StyledComponent";
import "./Wallet.css";
import axios from "axios";
import QRCode from "react-qr-code";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API_URLs } from "../../Utils/ApiUrls";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import Usdt from "../../images/Home/usdt.png";
import Matic from "../../images/Home/matic.png";
import Ether from "../../images/Home/ether.png";
import Usdc from "../../images/Home/USDC.png";
import CustomModal from "../../hooks/CustomModal";
import ButtonLoader from "../../Component/Loader/ButtonLoader";
import CrossIconWhite from "../../assets/WhiteCrossLogo.svg";
import CrossIconBlack from "../../assets/cross-logo.svg";
import ThemeContext, { useThemeContext } from "../../Context/ThemeContext";
import { darkTheme, lightTheme } from "../../Theme/theme";
import { useAuthContextHook } from "../../Context/AuthContext";
import { useAPIContextHook } from "../../Context/ApiContext";
import { useWalletContextHook } from "../../Context/WalletContext";
import DataTable, { createTheme } from "react-data-table-component";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Para } from "../Auth/SignUp/Otp";
import { Oval } from "react-loader-spinner";
import WAValidator from "multicoin-address-validator";

const DivWithMax = styled.div`
  display: flex;
  background: ${({ theme }) => theme.body};
  padding: 5px;
  box-shadow: ${({ theme }) => theme.boxshadow};
  border: ${({ theme }) => theme.border};
  border-radius: 15px;
  margin-top: 11px;
`;
const ButtonWithMax = styled.button`
  border: none;
  outline: none;
  background: #1476ff;
  width: 15%;
  color: white;
  border-radius: 15px;
`;
const InputWithMax = styled.input`
  width: 85%;
  border: none;
  background: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  outline: none;
`;
export const Small = styled.small`
  border-radius: 20px;
  background: aliceblue;
  padding: 1px 9px;
  color: #0088ff;
  font-size: 10px;
  font-weight: 600;
`;
const Div = styled.div`
  margin-top: 1rem;
  background: ${({ theme }) =>
    theme.body == "#F7F9FC" ? "white" : theme.body};
  padding: 0px !important;
  border-radius: 20px;
  border: ${({ theme }) => theme.border};
  box-shadow: ${({ theme }) => theme.boxshadow};
`;
const HoldingCard = styled.div`
  background: ${({ theme }) =>
    theme.body == "#F7F9FC" ? "white" : theme.body};
  border: ${({ theme }) => theme.border};
  box-shadow: ${({ theme }) => theme.boxshadow};
  border-radius: 20px;
`;
export default function CryptoBalance({ shown }) {
  // const {needToReload, setNeedToReload} = useContext(ThemeContext)
  const {
    getWallet,
    arr,
    getInBTC,
    arr1,
    getCryptoTransactionList,
    shouldReload,
    setShouldReload,
  } = useWalletContextHook();
  const { userDetails } = useAuthContextHook();
  const { cryptoCurrencyOptions, sendNotification } = useAPIContextHook();
  const { isDarkTheme } = useThemeContext();
  const [amount, setAmount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [copySuccess, setCopySuccess] = useState("");
  const [isSubmit, setisSubmit] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [navigateLink, setNavigateLink] = useState("");
  const [isCorrectWalletAdd, setIsCorrectWalletAdd] = useState(false);
  const [isKycNeed, setIsKycNeed] = useState(false);
  const handleShowModal = (data) => {
    setModalData(data);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsKycNeed(false);
  };

  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpHash, setOtpHash] = useState(false);
  const [isTwoFa, setIsTwoFa] = useState(false);
  const [isError, setIsError] = useState({
    errorMessage: "",
    errorStatus: false,
  });
  const handleSentOtpModal = (data) => {
    setOtpSent(true);
    setIsTwoFa(data);
  };

  const handleNotSentOtpModal = () => {
    setOtpSent(false);

    setAdminFee("");
    setEstGasFee("");
    formik1.setValues({
      cryptoAmount: "",
      currency: "",
    });
    window.history.pushState("", document.title, location.pathname);
    setOtpValue("");
    setOtpHash("");
    setGasFeeConvert("");
  };

  const [show1, setShow1] = useState(false);
  const [data1, setdata1] = useState([]);
  const handleClose1 = (isDataSafe = "noDataSafe") => {
    setShow1(false);
    if (!(isDataSafe === "keepDataSafe")) {
      formik1.setFieldValue("walletAddress", "");
      formik1.setFieldValue("cryptoAmount", "");
      formik1.setFieldValue("currency", "");
      setCalculationFees({});
    }
  };
  const handleShow1 = (data) => {
    setShow1(true);
    navigate("#qvani-wallet");
    setAmount(data.balance);
  };

  //recieve modal states
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setCopySuccess("");
  };
  const handleShow2 = (data) => {
    setShow2(true);
    setdata1({
      ...data,
      currency: data.currency === "POL" ? "POL (MATIC)" : data.currency,
    });
  };

  const [verify2FA, setVerify2FA] = useState(false);
  const [isOTPFill, setIsOTPFIll] = useState(false);

  const copyToClipBoard = useCallback(async (copyMe) => {
    setCopySuccess("");
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess("Copied!");
    } catch (err) {
      setCopySuccess("Failed to copy!");
    }
  }, []);

  const isValid = (value) => {
    let isValids = true;
    if (value.cryptoAmount <= 0 || !value?.cryptoAmount) {
      setIsError({
        ...isError,
        errorMessage: "Please enter amount greater than zero.",
      });
      isValids = false;
      return isValids;
    }
    if (value.cryptoAmount < 0.000001) {
      setIsError({
        ...isError,
        errorMessage: "Enter amount must be greater than 0.000001",
      });
      isValids = false;
      return isValids;
    }
    return isValids;
  };

  // send internal to external transaction
  const intToExt = (values) => {
    if (!isValid(values)) {
      return; 
    }
    setVerify2FA(true);
    axios
      .post(
        API_URLs.sendWithdrawal,
        {
          amount: values.cryptoAmount,
          recieverAddress: values.walletAddress,
          currencyType: values.currency.symbol === "matic" ? "pol" : values.currency.symbol,
          otp: otpValue,
          token: otpHash,
        },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        }
      )
      .then((res) => {
        handleClose1();
        getCryptoTransactionList();
        handleNotSentOtpModal();
        handleShowModal(
          res?.data?.msg
            ? res?.data?.msg
            : "Your Withdrawl Request Send Successfully!!"
        );
        setNavigateLink("");
        setVerify2FA(false);
        localStorage.removeItem("qrcode");
        setisSubmit(false);
        sendNotification(
          userDetails?.user?._id,
          `Transaction`,
          `Your withdrawal of ${res?.data?.data?.amount} ${res?.data?.data?.currency} has been completed successfully.`,
          // 'Your amount has been withdrawal successfully',
          "transaction",
          { transactionType: "wallet" }
        );
        getWallet();
      })
      .catch((error) => {
        localStorage.removeItem("qrcode");
        setisSubmit(false);
        setVerify2FA(false);
        handleNotSentOtpModal();
        handleClose1();

        if (error.response.data.message.includes("{")) {
          const response = JSON.parse(error.response.data.message);
          handleShowModal(response?.msg ? response?.msg : "Some Error Occured");
          setIsKycNeed(response?.isKycNeeded);
        } else {
          handleShowModal(error.response.data.message ? error.response.data.message : "Transaction failed due to blockchain network issue");
          sendNotification(
            userDetails?.user?._id,
            `Transaction`,
            error.response.data.message ? error.response.data.message : "Transaction failed due to blockchain network issue",
            "transaction",
            { transactionType: "wallet" }
          );
        }
      });
  };

  const intToInt = async (values) => {
    if (!isValid(values)) {
      return;
    }
    setVerify2FA(true);
    const body = {
      ...(values?.currency?.symbol === ("usdt" || "usdc" || "btc") ? 
        {
          amountToSend: values.cryptoAmount,
        } : {
          amount: values.cryptoAmount,
        }
      ),
        reciverNickName: values.walletAddress,
        otp: otpValue,
        token: otpHash,
    }
    console.log("body", body);

    try {
      let res = await axios.post(API_URLs.sendIntTx(values?.currency?.symbol), body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            Accept: "application/json"
          },
        }
      );
      setisSubmit(false);
      getCryptoTransactionList();
      handleNotSentOtpModal();
      setNavigateLink("");
      handleShowModal(res?.data?.msg ? res?.data?.msg : "Send Successfully!!");
      localStorage.removeItem("qrcode");
      let reciever = res?.data?.receiverId;

      sendNotification(
        reciever,
        `Transaction`,
        `${values.cryptoAmount} ${values?.currency?.symbol} has been credited to your account`,
        "transaction",
        { transactionType: "wallet" }
      );

      sendNotification(
        userDetails?.user?._id,
        `Transaction`,
        `${values.cryptoAmount} ${values?.currency?.symbol} has been debited from your account`,
        "transaction",
        { transactionType: "wallet" }
      );

      setVerify2FA(false);
      getWallet();
    } catch (error) {
      setVerify2FA(false);
      localStorage.removeItem("qrcode");
      setNavigateLink("");
      setisSubmit(false);
      handleNotSentOtpModal();
      if (error.response.data.message.includes("{")) {
        const response = JSON.parse(error.response.data.message);
        handleShowModal(response?.msg ? response?.msg : "Some Error Occured");
        setIsKycNeed(response?.isKycNeeded);
      } else {
        handleShowModal(error.response.data.message ? error.response.data.message : "Transaction failed due to blockchain network issue");
        sendNotification(
          userDetails?.user?._id,
          `Transaction`,
          error.response.data.message ? error.response.data.message : "Transaction failed due to blockchain network issue",
          "transaction",
          { transactionType: "wallet" }
        );
      }
    }
  }

  // send modal form
  const formik1 = useFormik({
    initialValues: { walletAddress: "", cryptoAmount: "", currency: "" },
    validationSchema: Yup.object({
      currency: Yup.object().shape({
        value: Yup.string().required("Currency is Required"),
      }),
      walletAddress: Yup.string().required("This Field is Required"),
      cryptoAmount: Yup.string().required("Amount is Required"),
    }),
    onSubmit: (value) => {
      if (!isValid(value)) {
        return;
      } else if (amount < value?.cryptoAmount) {
        setModalData("Enter amount must be less than wallet balance");
        setShowModal(true);
      } else if (
        location.hash.includes("external-wallet") &&
        (value.currency.symbol === "usdc" || value.currency.symbol === "usdt") && value.cryptoAmount < 7
      ) {
        const result = arr.filter((f) => {
          return f.currency.toLowerCase() === value.currency.symbol;
        });
        if (result[0].balance < 7) {
          setModalData(
            `You must have a minimum amount 7 ${value.currency.symbol} in your account, to withdraw.`
          );
          setShowModal(true);
        } else {
          
        }
      } else if (
        userDetails?.KycLimitStatus?.limit_exceed &&
        location?.hash?.includes("#qvani-wallet")
      ) {
        setModalData(
          `You exceeded the maximum Trade Volume Lifetime Limit of $${"100,000"}. Please complete basic KYC to unpause your offers and have unlimited trade volume.`
        );
        setShowModal(true);
        setIsKycNeed(true);
      } else {
        setisSubmit(true);
        axios
          .post(
            API_URLs.verify2faTxn,
            {},
            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${localStorage?.getItem("jwt")}`,
              },
            }
          )
          .then((res) => {
            setisSubmit(false);
            if (res.data.isTwoFa) {
              if (res.data.responses.img) {
                localStorage.setItem("qrcode", res?.data?.responses?.img);
              }
              setOtpHash(res?.data?.responses?.token);
            } else {
              setOtpHash(res?.data?.responses);
            }
            handleSentOtpModal(res?.data?.isTwoFa);
            handleClose1("keepDataSafe");
          })
          .catch((err) => {
          });
      }
    },
  });

  const handleVerify2FA = () => {
    location.hash.includes("external-wallet")
      ? intToExt(formik1.values)
      : intToInt(formik1.values);
  };

  const handleSetMax = () => {
    let main =
      amount === 0
        ? 0
        : amount - Number(estGasFee) <= 0
        ? 0
        : amount - Number(estGasFee);
    formik1.setValues({
      walletAddress: formik1?.values?.walletAddress,
      currency: formik1?.values?.currency,
      cryptoAmount: main.toString(),
    });
    isValidaAdd &&
      calEst(
        "",
        main.toString(),
        formik1?.values?.walletAddress,
        formik1?.values?.currency
      );
  };

  useEffect(() => {
    getWallet();
    getInBTC();
    if (!userDetails?.user?.currency) {
      handleShowModal("Select your preferred currency, first!!");
      setNavigateLink("/dashboard/settings#preference");
    }
  }, [shouldReload]);

  const CurrencyObj = {
    ETH: { name: "Ethereum", shortName: "ETHER", img: Ether },
    BTC: { name: "Bitcoin", shortName: "BTC", img: Btc },
    USDC: { name: "USD Coin", shortName: "USDC", img: Usdc },
    USDT: { name: "Tether", shortName: "USDT", img: Usdt },
    POL: { name: "Polygon", shortName: "POL (MATIC)", img: Matic },
  };
  // const option = [
  //   {
  //     icon: "",
  //     link: "",
  //     title: ""
  //   }
  // ]

  // wallet column format
  const walletColumn = [
    {
      name: <p className="fw-bold mb-0 fs-6">CURRENCY</p>,
      selector: (row) => (
        <div className="d-flex justify-content-between align-items-center gap-1">
          <ImgDiv>
            <img src={CurrencyObj[row.currency]?.img} alt="" width="100%" />
          </ImgDiv>
          <div className="d-flex gap-1">
            <p className="mb-0 fw-bold">{CurrencyObj[row.currency]?.name}</p>
            <Small className="d-none d-md-block text-secondary">
              {CurrencyObj[row.currency]?.shortName}
            </Small>
          </div>
        </div>
      ),
    },
    {
      name: <p className="fw-bold mb-0 fs-6">AMOUNT</p>,
      selector: (row) => (
        <div>
          {row?.balance !== undefined && row?.balance !== null
            ? Number(row.balance || 0) <= 0
              ? "0.0000000000"
              : row.balance.toFixed(10)
            : "0.0000000000"}
        </div>
      ),
    },
    {
      name: (
        <p className="fw-bold mb-0 fs-6">
          IN{" "}
          {userDetails?.user?.currency
            ? userDetails?.user?.currency?.symbol
            : "USD"}
        </p>
      ),
      selector: (row) => <div>{row?.convert}</div>,
    },
    {
      name: <p className="fw-bold mb-0 fs-6">NETWORK</p>,
      selector: (row) => <div>{row?.network}</div>,
    },
    {
      name: <p className="fw-bold mb-0 fs-6 text-center">ACTION</p>,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="d-md-flex d-none">
            <div
              className="d-flex flex-column gap-1 text-align-center justify-content-center sendcryptobuttonfortour"
              title="Send"
              onClick={() => handleShow1(row)}
            >
              <BsFillSendFill
                size={17}
                style={{ color: "#1476FF", alignSelf: "center" }}
              />
              <small className="mb-0 d-flex flex-row text-secondary">
                Send
              </small>
            </div>
            <div
              className="d-flex flex-column gap-1 px-3 text-align-center justify-content-center getcryptobuttonfortour"
              title="Send"
              onClick={() => handleShow2(row)}
            >
              <MdCallReceived
                size={17}
                style={{ color: "#1476FF", alignSelf: "center" }}
              />
              <small className="mb-0 text-secondary">Receive</small>
            </div>
            <div
              className="d-flex flex-column gap-1 text-align-center justify-content-center convertbutton"
              onClick={() => navigate("/dashboard/wallet#convert")}
              title="Convert"
            >
              <GiRecycle
                size={17}
                style={{ color: "#1476FF", alignSelf: "center" }}
              />
              <small className="mb-0 text-secondary">Convert</small>
            </div>
            <div className="dropdown px-2 moreoptionbutton">
              <a
                className=""
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <BsThreeDots />
              </a>
              <ul
                className="dropdown-menu bg-white"
                aria-labelledby="dropdownMenuButton1"
              >
                <Link
                  className="dropdown-item"
                  to={`/dashboard/buy/${row.currency_id}`}
                >
                  Buy
                </Link>
                <Link
                  className="dropdown-item"
                  to={`/dashboard/sell/${row.currency_id}`}
                >
                  Sell
                </Link>
              </ul>
            </div>
          </div>

          <div className="dropdown px-2 d-md-none d-sm-block d-flex justify-content-center align-items-center">
            <a
              className=""
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <BsThreeDots />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-on-small bg-white"
              aria-labelledby="dropdownMenuButton1"
            >
              <div className="d-flex gap-1 px-2" onClick={() => handleShow1()}>
                <BsFillSendFill
                  size={17}
                  style={{ color: "#1476FF", alignSelf: "center" }}
                />
                <Link
                  className="dropdown-item px-0 text-secondary"
                  // to={"/dashboard/wallet#convert"}
                >
                  Send
                </Link>
              </div>

              <div className="d-flex gap-1 px-2" onClick={() => handleShow2(row)}>
                <MdCallReceived
                  size={17}
                  style={{ color: "#1476FF", alignSelf: "center" }}
                />
                <Link
                  className="dropdown-item px-0 text-secondary"
                  // to={"/dashboard/wallet#convert"}
                >
                  Receive
                </Link>
              </div>

              <div className="d-flex gap-1 px-2">
                <GiRecycle
                  size={17}
                  style={{ color: "#1476FF", alignSelf: "center" }}
                />
                <Link
                  className="dropdown-item px-0 text-secondary"
                  to={"/dashboard/wallet#convert"}
                >
                  Convert
                </Link>
              </div>

              <div className="d-flex gap-1 px-2">
                <MdCallReceived
                  size={17}
                  style={{ color: "#1476FF", alignSelf: "center" }}
                />
                <Link
                  className="dropdown-item px-0 text-secondary"
                  to={`/dashboard/buy/${row?.currency_id}`}
                >
                  Buy
                </Link>
              </div>

              <div className="d-flex gap-1 px-2">
                <MdCallReceived
                  size={17}
                  style={{ color: "#1476FF", alignSelf: "center" }}
                />
                <Link
                  className="dropdown-item px-0 text-secondary"
                  to={`/dashboard/sell/${row.currency_id}`}
                >
                  Sell
                </Link>
              </div>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  const walletColumnforDash = [
    {
      name: <p className="fw-bold mb-0 fs-6">CURRENCY</p>,
      selector: (row) => (
        <div className="d-flex justify-content-between align-items-center gap-1">
          <ImgDiv>
            <img src={CurrencyObj[row.currency].img} alt="" width="100%" />
          </ImgDiv>
          <div className="d-flex gap-1">
            <p className="mb-0 fw-bold">{CurrencyObj[row.currency].name}</p>
            <Small className="d-none d-md-block text-secondary">
              {CurrencyObj[row.currency].shortName}
            </Small>
          </div>
        </div>
      ),
    },
    {
      name: <p className="fw-bold mb-0 fs-6">AMOUNT</p>,
      selector: (row) => (
        <div>
          {row?.balance !== undefined && row?.balance !== null
            ? Number(row.balance || 0) <= 0
              ? "0.0000000000"
              : row.balance.toFixed(10)
            : "0.0000000000"}
          {/* {(row?.balance || 0)?.toFixed(12)} */}
        </div>
      ),
    },
    {
      name: (
        <p className="fw-bold mb-0 fs-6">
          IN{" "}
          {userDetails?.user?.currency
            ? userDetails?.user?.currency?.symbol
            : "USD"}
        </p>
      ),
      selector: (row) => <div>{row.convert}</div>,
    },
    {
      name: <p className="fw-bold mb-0 fs-6">NETWORK</p>,
      width: "180px",
      selector: (row) => <div>{row?.network}</div>,
    },
  ];
  createTheme("solarized", {
    background: {
      default: `${isDarkTheme ? "#0c0c0c" : "white"}`,
    },
    action: {
      hover: "rgba(0,0,0,.08)",
    },
    text: {
      secondary: `${isDarkTheme ? "white" : "black"}`,
    },
  });

  const customStyles = {
    header: {
      style: {
        fontSize: "20px",
        color: "#0B0E2C",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "600",
      },
    },
    headRow: {
      style: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontSize: "12px",
        ...(isDarkTheme
          ? { borderTop: "1px solid #302f30" }
          : { border: "1px solid lightgray" }),
        color: `${isDarkTheme ? "#e9e9e9" : "#6F7182"}`,
        backgroundColor: `${isDarkTheme ? "#0c0d0d" : "#F7F9FC"}`,
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        color: `${isDarkTheme && "white"}`,
        backgroundColor: `${isDarkTheme && "rgba(8, 9, 14, 0.96)"}`,
        borderTop: "1px solid lightgray",
        "&:not(:last-of-type)": {
          borderBottom: "none",
        },
      },
    },
    headCells: {
      style: {
        display: "flex",
        alignItems: "center",
      },
    },
    cells: {
      style: {
        display: "flex",
        alignItems: "center",
        mixWidth: "164px",
      },
    },
  };
  const styles = {
    control: (styles) => ({
      ...styles,
      background: "transparent",
      borderRadius: "52px",
      width: "100%",
      height: "50px",
      color: "white",
      boxShadow: `${isDarkTheme ? darkTheme.boxshadow : lightTheme.boxshadow}`,
      border: `${isDarkTheme ? darkTheme.border : lightTheme.border}`,
      "&:hover": {
        border: `${isDarkTheme ? darkTheme.border : lightTheme.border}`,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        isDarkTheme && state.isHovered
          ? "#302F30"
          : `${({ theme }) => theme.body}`,
      ":hover": {
        backgroundColor: `${isDarkTheme ? "#302F30" : "#D9EDE7"}`,
      },
      color:
        isDarkTheme && state.isSelected
          ? "#1476FF"
          : `${({ theme }) => theme.text}`,
    }),
    indicatorSeparator: () => ({
      all: "unset",
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      color: isDarkTheme ? "white" : "black",
      "div:nth-child(2)": {
        color: isDarkTheme ? "white" : lightTheme.text,
      },
    }),
    menu: (styles) => ({
      ...styles,
      background: isDarkTheme ? "rgb(27, 27, 28)" : "white",
      color: isDarkTheme ? "white" : lightTheme.text,
    }),
  };

  const isTabSelected =
    location.hash.includes("qvani-wallet") ||
    location.hash.includes("external-wallet");
  const [estGasFee, setEstGasFee] = useState("");
  const [adminFee, setAdminFee] = useState("");
  const [gasFeeConvert, setGasFeeConvert] = useState("");
  const [calculationFees, setCalculationFees] = useState({});
  const [ovalLoader, setOvalLoader] = useState(false);
  const [isValidaAdd, setIsValidAdd] = useState(true);

  const validationWalletAddress = async (
    address = "",
    currencyNameOrSymbol = "",
    network = "mainnet"
  ) => {
    currencyNameOrSymbol =
      currencyNameOrSymbol === "pol" ? "matic" : currencyNameOrSymbol;
    const isValid = WAValidator.validate(address, currencyNameOrSymbol);
    setIsValidAdd(isValid);
    return isValid;
  };

  const handleCalculate = (id, values, amountValue, type) => {
    if (
      values?.walletAddress &&
      (values?.cryptoAmount || amountValue) &&
      values?.currency
    ) {
      setOvalLoader(true);
      axios.get(
          API_URLs.getEstimation(
            id || formik1?.values?.currency?._id,
            amountValue || values?.cryptoAmount,
            values?.walletAddress,
            type
          ),
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        )
        .then((res) => {
          setCalculationFees(res?.data?.result);
          for (let key in res.data.result) {
            if (
              key !== "adminFee" &&
              key !== "adminFeeInUSD" &&
              key !== "gasFeeInUSD"
            ) {
              setEstGasFee(res.data.result[key]);
              axios
                .get(
                  API_URLs?.cryptoToFiat +
                    "?from=" +
                    formik1?.values?.currency?.value +
                    "&amount=" +
                    res?.data?.result?.[key] +
                    "&target=" +
                    userDetails?.user?.currency?._id,
                  {
                    headers: {
                      accept: "application/json",
                      Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                    },
                  }
                )
                .then((res) => {
                  setGasFeeConvert(res?.data?.convertedRate);
                })
                .catch((error) => {});
            } else {
              setAdminFee(res?.data?.result?.[key]);
            }
          }
          setIsCorrectWalletAdd(false);
        })
        .catch((err) => {
          handleShowModal(err?.response?.data?.message);
          setNavigateLink("");
          setIsCorrectWalletAdd(true);
        })
        .finally(() => {
          setOvalLoader(false);
        });
    }
  };

  const calEst = (
    id = formik1.values?.currency?._id || "",
    amountValue = 0,
    walletAddress = "",
    currency = "",
    withdrawalType = "",
    callOrigin = ""
  ) => {
    if (
      (formik1?.values?.walletAddress || walletAddress) &&
      (formik1?.values?.cryptoAmount >= 0.000001 || amountValue >= 0.000001) &&
      (formik1?.values?.currency || currency)
    ) {
      (
        callOrigin === "walletType"
          ? withdrawalType === "external-wallet"
          : location.hash.includes("external-wallet")
      )
        ? handleCalculate(id, formik1.values, amountValue, "external")
        : handleCalculate(id, formik1.values, amountValue, "internal");
      // (withdrawalType==='external-wallet') ? handleCalculate(id, formik1.values,amountValue, 'external') : handleCalculate(id, formik1.values,amountValue, 'internal')
    }
  };

  const [time, setTime] = useState(600);

  useEffect(() => {
    const interval = setInterval(() => {
      if (time > 0) {
        setTime(time - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [time]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  useEffect(() => {}, [calculationFees]);

  function isAnyError() {
    if (formik1?.values?.cryptoAmount < 0.000001) return true;
    return false;
  }

  return (
    <div>
      {shown && (
        <div className="row m-0 d-flex justify-content-center">
          <HoldingCard className="totalholdingboxfortour col-md-4 py-2 px-3 col-sm-12 d-flex flex-column justify-content-center align-items-center card">
            <p className="mb-0 fw-bold">Total Holdings</p>
            <small className="mb-0 text-secondary">
              Total Value of wallet Assets
            </small>
            <hr className="my-2" />
            <p className="mb-0 fw-bold">
              {arr1 ? Number(arr1[0]?.amount).toFixed(10) : "0"} BTC
            </p>
            <p className="mb-0">
              <span style={{ fontSize: "17px", fontWeight: "700" }}>≈</span>{" "}
              {arr1[0]?.convert ? arr1[0]?.convert?.toFixed(2) : "0"}{" "}
              {userDetails?.user?.currency?.symbol}
            </p>
          </HoldingCard>
        </div>
      )}
      <div className="row m-0 d-flex flex-wrap allwalletdetailsfortour">
        <Div>
          <p style={{ margin: "13px", fontSize: "16px", fontWeight: "700" }}>
            Assets
          </p>
          <DataTable
            className="mywallettable allwalletdetailsfortour"
            data={arr}
            columns={shown ? walletColumn : walletColumnforDash}
            customStyles={customStyles}
            highlightOnHover
            theme="solarized"
            progressComponent={<Oval width={50} height={50} />}
            progressPending={arr?.length === 0}
            style={{ overflowX: "hidden" }}
          />
        </Div>

        <Modal
          style={{ background: "transparent" }}
          show={show1}
          onHide={handleClose1}
        >
          <Modal.Header
            style={{ background: isDarkTheme ? "#0c0c0c" : "white" }}
          >
            <Modal.Title>
              <MdCallMade /> Send Your Crypto
            </Modal.Title>
            <img
              role="button"
              onClick={handleClose1}
              src={isDarkTheme ? CrossIconWhite : CrossIconBlack}
              alt="Close"
            />
          </Modal.Header>
          {ovalLoader && (
            <div className="oval_loader">
              <Oval width={50} height={50} />
            </div>
          )}
          <Modal.Body style={{ background: isDarkTheme ? "#0c0c0c" : "white" }}>
            <form
              onSubmit={formik1.handleSubmit}
              className="d-flex flex-column gap-3"
            >
              <div>
                <Label>Select Currency</Label>
                <Select
                  className="select"
                  name="currency"
                  id="currency"
                  placeholder="Select Currency"
                  height="100%"
                  width="100%"
                  options={cryptoCurrencyOptions}
                  styles={styles}
                  onChange={async (selectedValues) => {
                    const walletAmount = arr.filter((crypt) => {
                      if (
                        (crypt?.currency || "")?.toLowerCase() ===
                        selectedValues?.symbol
                      )
                        return crypt;
                    });
                    setAmount(walletAmount?.[0]?.balance);
                    let event = {
                      target: { name: "currency", value: selectedValues },
                    };
                    formik1.handleChange(event);
                    // calEst(selectedValues?._id)
                    // await validationWalletAddress(formik1?.values?.walletAddress, selectedValues?.symbol) && calEst(selectedValues?._id)
                  }}
                  onBlur={(selectedValues) => {
                    let event = {
                      target: { name: "currency", value: selectedValues },
                    };
                    formik1.handleBlur(event);
                  }}
                  value={formik1.values.currency}
                />
                <small>
                  {formik1.errors.currency && formik1.touched.currency && (
                    <div className="input-feedback text-danger auth-error text-start">
                      {String(formik1.errors.currency?.value).replace(
                        ".value",
                        ""
                      )}
                    </div>
                  )}
                </small>
              </div>
              <div>
                <div className="d-flex justify-content-between">
                  <Label className="mt-1" htmlFor="walletAddress">
                    Enter Wallet Address
                  </Label>
                  <div className="tab-navigator">
                    <ul
                      className="nav nav-tabs crypto-send d-flex gap-1 gap-sm-3"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item text-decoration-none">
                        <TabNavigationButton
                          className={`nav-link nav-li-link gap-1 fontSize p-0 ${
                            isTabSelected
                              ? location.hash.includes("qvani-wallet")
                                ? "active"
                                : ""
                              : "active"
                          }`}
                          id="qvani-wallet-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#qvani-wallet"
                          type="button"
                          role="tab"
                          aria-controls="qvani-wallet"
                          walletAddress
                          onClick={() => {
                            isValidaAdd &&
                              calEst(
                                "",
                                "",
                                "",
                                "",
                                "qvani-wallet",
                                "walletType"
                              );
                            navigate("#qvani-wallet");
                          }}
                          aria-selected="true"
                        >
                          Qvani Address
                        </TabNavigationButton>
                      </li>
                      <li className="nav-item text-decoration-none">
                        <TabNavigationButton
                          className={`nav-link gap-1 p-0 nav-li-link fontSize ${
                            isTabSelected
                              ? location.hash.includes("external-wallet")
                                ? "active"
                                : ""
                              : ""
                          }`}
                          id="external-wallet-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#external-wallet"
                          type="button"
                          role="tab"
                          aria-controls="external-wallet"
                          onClick={() => {
                            // calEst()
                            isValidaAdd &&
                              calEst(
                                "",
                                "",
                                "",
                                "",
                                "external-wallet",
                                "walletType"
                              );
                            navigate("#external-wallet");
                          }}
                          aria-selected="true"
                        >
                          External Address
                        </TabNavigationButton>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="tab-content" id="myTabContent">
                  <div
                    className={`tab-pane fade ${
                      isTabSelected
                        ? location.hash.includes("qvani-wallet")
                          ? "show active"
                          : ""
                        : "show active"
                    }`}
                    id="qvani-wallet"
                    role="tabpanel"
                    aria-labelledby="qvani-wallet-tab"
                  >
                    <Input
                      id="walletAddress"
                      name="walletAddress"
                      placeholder="Enter Wallet Address Here"
                      value={formik1.values.walletAddress}
                      onChange={async (e) => {
                        formik1.handleChange(e);
                        // (await validationWalletAddress(
                        //   e?.target?.value,
                        //   formik1?.values?.currency?.symbol
                        // )) && calEst();
                        calEst()
                      }}
                      onBlur={(event) => {
                        isValidaAdd && calEst();
                        formik1.handleBlur(event);
                      }}
                    />
                    <small>
                      {formik1.errors.walletAddress &&
                        formik1.touched.walletAddress && (
                          <div className="input-feedback text-danger auth-error text-start">
                            {formik1.errors.walletAddress}
                          </div>
                        )}
                    </small>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      isTabSelected
                        ? location.hash.includes("external-wallet")
                          ? "show active"
                          : ""
                        : ""
                    }`}
                    id="external-wallet"
                    role="tabpanel"
                    aria-labelledby="external-wallet-tab"
                  >
                    <Input
                      id="walletAddress"
                      name="walletAddress"
                      placeholder="Enter Wallet Address Here"
                      value={formik1.values.walletAddress}
                      onChange={(e) => {
                        formik1.handleChange(e);
                        // validationWalletAddress(
                        //   e?.target?.value,
                        //   formik1?.values?.currency?.symbol
                        // ) && calEst();
                        calEst();
                      }}
                      onBlur={(event) => {
                        isValidaAdd && calEst();
                        formik1.handleBlur(event);
                      }}
                    />
                    <small>
                      {isValidaAdd &&
                        formik1.errors.walletAddress &&
                        formik1.touched.walletAddress && (
                          <div className="input-feedback text-danger auth-error text-start">
                            {formik1.errors.walletAddress}
                          </div>
                        )}
                    </small>
                  </div>
                  {!isValidaAdd && formik1.values.walletAddress != "" && (
                    <div className="input-feedback text-danger auth-error text-start m-0">
                      Invalid wallet address
                    </div>
                  )}
                </div>
              </div>
              <div>
                <Label htmlFor="cryptoAmount">Enter Amount</Label>
                <DivWithMax>
                  <InputWithMax
                    id="cryptoAmount"
                    name="cryptoAmount"
                    placeholder={`Enter Amount (${amount} is maximum)`}
                    value={formik1.values.cryptoAmount}
                    onChange={(e) => {
                      const regex = new RegExp(/^\d*\.?\d*$/);
                      if (regex.test(e.target.value) || e.target.value === "") {
                        formik1.handleChange(e);
                        setIsError({ ...isError, errorMessage: "" });
                        if (e?.target?.value >= 0.000001 && isValidaAdd) {
                          calEst("", e?.target?.value);
                        }
                      }
                    }}
                    onBlur={(event) => {
                      // event?.target?.value >= 0.000001 && calEst()
                      // formik1.handleBlur(event)
                    }}
                  />
                  <ButtonWithMax onClick={() => handleSetMax()} type="button">
                    Max
                  </ButtonWithMax>
                </DivWithMax>
                {formik1?.values?.cryptoAmount < 0.000001 &&
                  formik1?.values?.cryptoAmount !== "" && (
                    <div className="input-feedback text-danger auth-error text-start">
                      Balance should not be less than 0.000001
                    </div>
                  )}
                {calculationFees &&
                  calculationFees?.adminFee > formik1.values.cryptoAmount && (
                    <div className="input-feedback text-danger auth-error text-start">
                      Amount must be greater then the fee
                    </div>
                  )}
                <small>
                  {formik1.errors.cryptoAmount &&
                    formik1.touched.cryptoAmount && (
                      <div className="input-feedback text-danger auth-error text-start">
                        {formik1.errors.cryptoAmount}
                      </div>
                    )}
                  {isError?.errorMessage && (
                    <p className="m-0 text-danger">{isError?.errorMessage}</p>
                  )}
                </small>
              </div>
              {(formik1?.values.currency?.symbol == "usdc" ||
                formik1?.values.currency?.symbol == "usdt") &&
                !location?.hash?.includes("#qvani-wallet") && (
                  <p className="m-0 warning_text">
                    * You must have a minimum amount 7{" "}
                    {(formik1?.values.currency?.symbol || "")?.toUpperCase()} to
                    withdraw. Please refer to our{" "}
                    <a href="https://qvani.com/terms" target="_blank">
                      Terms of Service
                    </a>{" "}
                    for more details
                  </p>
                )}
              <div>
                <ReqButton
                  disabled={
                    isSubmit ||
                    isCorrectWalletAdd ||
                    !isValidaAdd ||
                    isAnyError()
                  }
                  type="submit"
                >
                  {isSubmit ? (
                    <p className="mb-0 d-flex justify-content-center align-items-center">
                      <ButtonLoader />
                      <span>Send</span>
                    </p>
                  ) : (
                    <span>Send</span>
                  )}
                </ReqButton>
              </div>
            </form>
            <span className="mt-3 d-flex gap-1">
              <h6>Gas Fee (Estimated): </h6>
              {/* <small className='text-uppercase'>{' '}{calculationFees && Object.keys(calculationFees)?.length > 0  
                            ? `${formik1?.values?.currency !='' && calculationFees?.[formik1?.values?.currency?.symbol]?.toFixed(10) || 0 } ${formik1?.values?.currency && formik1?.values?.currency?.symbol}` : `0 ${formik1?.values?.currency && formik1?.values?.currency?.symbol}`} 
                                {` ≈ ${ calculationFees?.gasFeeInUSD > 0 ? calculationFees?.gasFeeInUSD?.toFixed(2) : 0} USD`}
                            </small> */}
              <small className="text-uppercase">
                {" "}
                {calculationFees && Object.keys(calculationFees)?.length > 0
                  ? `${
                      formik1?.values?.currency
                        ? Number(
                            calculationFees[
                              formik1?.values?.currency?.symbol
                            ] || 0
                          )?.toFixed(10)
                        : 0
                    }
                                ${formik1?.values?.currency?.symbol || ""}`
                  : `0 ${formik1?.values?.currency?.symbol || ""}`}
                {` ≈ ${
                  calculationFees?.Assets && calculationFees?.gasFeeInUSD > 0
                    ? Number(calculationFees?.gasFeeInUSD || 0)?.toFixed(2)
                    : 0
                } USD`}
              </small>
            </span>
            <span className="mt-3 d-flex gap-1">
              <h6>Admin Fee:</h6>
              <small className="text-uppercase">
                {calculationFees?.adminFee
                  ? `${Number(calculationFees?.adminFee || 0)?.toFixed(10)} 
                                ${formik1?.values?.currency?.symbol}`
                  : `0 ${
                      formik1?.values?.currency &&
                      formik1?.values?.currency?.symbol
                    }`}
                {` ≈ ${
                  calculationFees?.adminFeeInUSD > 0
                    ? Number(calculationFees?.adminFeeInUSD || 0)?.toFixed(2)
                    : 0
                } USD`}
              </small>
            </span>
          </Modal.Body>
        </Modal>

        <Modal show={show2} onHide={handleClose2}>
          <Modal.Header
            style={{ background: isDarkTheme ? "#0c0c0c" : "white" }}
          >
            <Modal.Title>Your {data1?.currency} Address</Modal.Title>
            <img
              role="button"
              onClick={handleClose2}
              src={isDarkTheme ? CrossIconWhite : CrossIconBlack}
              alt="Close"
            />
          </Modal.Header>
          <Modal.Body style={{ background: isDarkTheme ? "#0c0c0c" : "white" }}>
            <div className="d-flex p-3">
              {data1.address && (
                <QRdiv className="bg-white rounded-2 p-2">
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100px" }}
                    value={data1.address}
                    viewBox={`0 0 256 256`}
                  />
                </QRdiv>
              )}
            </div>
            <div>
              <p className="fw-bold fs-4 m-0 mt-2">
                Your {data1.currency} Address:
              </p>
              <small className="fw-bold">
                Use this address to deposit {data1.currency}
              </small>
              <br />
              <div className="d-flex gap-2">
                <small>{data1.address}</small>
                <BiCopy
                  onClick={() => copyToClipBoard(data1.address)}
                  role="button"
                  title="copy"
                  size={17}
                />
              </div>
              <small className="fw-bold">{copySuccess}</small>
            </div>
            {(data1.currency === "USDC" || data1.currency === "USDT") && (
              <p className="m-0 mt-1 warning_text">
                * You must deposit more than the minimum amount 20{" "}
                {data1?.currency}. Please refer to our{" "}
                <a href="https://qvani.com/terms" target="_blank">
                  Terms of Service
                </a>{" "}
                for more details.
              </p>
            )}
          </Modal.Body>
        </Modal>

        <Modal show={otpSent}>
          <Modal.Header className="d-flex align-items-center justify-content-between">
            <img
              role="button"
              onClick={handleNotSentOtpModal}
              src={isDarkTheme ? CrossIconWhite : CrossIconBlack}
              alt="Close"
            />
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center align-items-center verify-two-fa-txn m-0 flex-column">
              {localStorage.getItem("qrcode") && (
                <img
                  className="w-50"
                  src={localStorage.getItem("qrcode")}
                  alt="QR Code"
                />
              )}
              <p className="text-center mb-2">
                We have sent a verification code to your email. Verification
                code is valid for 10 minutes only. Please check your email.
              </p>
              <OTPInput
                className="OtpInputBox"
                value={otpValue}
                onChange={setOtpValue}
                autoFocus
                OTPLength={isTwoFa ? 6 : 4}
                otpType="number"
                disabled={false}
                secure
              />
              {time === 0 ? (
                <Para className="text-center pt-3 mb-1">
                  Verification code has been expired
                </Para>
              ) : (
                <Para className="text-center pt-3 mb-1">
                  Verification code will expire in {formatTime(time)} minutes
                </Para>
              )}
              <button
                disabled={time != 0}
                className="resetOTPBTN"
                onClick={() => {
                  formik1.handleSubmit();
                  setTime(600);
                }}
              >
                Re-send OTP
              </button>
              <ReqButton
                disabled={verify2FA || !(otpValue.length == 4)}
                onClick={() => handleVerify2FA()}
                className="text-center"
              >
                {verify2FA ? "verifying..." : "Verify"}
              </ReqButton>
            </div>
          </Modal.Body>
        </Modal>

        {showModal && (
          <CustomModal
            show={showModal}
            handleClose={handleCloseModal}
            navigateLink={navigateLink}
            data={modalData}
            isKycNeed={isKycNeed}
          />
        )}
      </div>
    </div>
  );
}

CryptoBalance.propTypes = {
  loader: PropTypes.bool.isRequired,
  completeeOffer: PropTypes.shape().isRequired,
};
